import { ReservationInput, ReservationInterface } from '../../interfaces';
import { OrderBatch } from '../../types/order-batch';
import reservationClient from '../reservation-client';

interface ReservationsRequest {
  product: string;
  campaign: string;
  batches: OrderBatch[];
}

const handleBatch = async (
  batch: OrderBatch,
  campaign: string,
  product: string
): Promise<ReservationInterface[]> => {
  if (!batch.dates) return [];
  const reservationData: ReservationInput[][] = batch.dates.map(
    (date: Date): ReservationInput[] => {
      const base = {
        date: date.toISOString().substring(0, 10),
        campaign,
        product,
        quantity: batch.quantity,
        rough: false,
        batch: batch.id,
      };
      const reservation = batch.variations.map((variation: string) => {
        return { ...base, variation };
      });
      return reservation;
    }
  );
  const reservations = reservationData.flat();
  const creations = reservations.map((reservation) =>
    reservationClient.addReservation({ ...reservation })
  );
  const result = await Promise.all(creations);
  return result;
};
const addReservations = async ({
  product,
  campaign,
  batches,
}: ReservationsRequest): Promise<ReservationInterface[]> => {
  const creations = batches.map(async (batch) => {
    batch.variations = [...new Set(batch.variations)];
    return handleBatch(batch, campaign, product);
  });
  const result = await Promise.all(creations);
  return result.flat();
};

export default addReservations;
